
import RealTimeQuote from '@/provider/RealtimeQuote.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheSymbolMarketState',
  components: { RealTimeQuote },
  props: {
    symbol: {
      type: Object,
      required: true,
    },
  },
})
